import {
   createContext,
   useContext,
   useMemo,
   useRef,
   useSyncExternalStore,
} from "react";

import { createCalendarStore } from "./calendarStore";

const CalendarStoreContext = createContext(null);

export function CalendarStoreProvider({ store, children }) {
   const storeRef = useRef(store || null);
   if (!storeRef.current) {
      storeRef.current = createCalendarStore();
   }
   const value = useMemo(
      () => ({
         store: store || storeRef.current,
      }),
      [store],
   );
   return (
      <CalendarStoreContext.Provider value={value}>
         {children}
      </CalendarStoreContext.Provider>
   );
}

export function useCalendarStore() {
   const ctx = useContext(CalendarStoreContext);
   if (!ctx?.store) {
      throw new Error("useCalendarStore must be used within CalendarStoreProvider");
   }
   return ctx.store;
}

export function useCalendarStoreSnapshot(selector = (snapshot) => snapshot) {
   const store = useCalendarStore();
   return useStoreSnapshot(store, selector);
}

export function useStoreSnapshot(store, selector = (snapshot) => snapshot) {
   return useSyncExternalStore(
      store.subscribe.bind(store),
      () => selector(store.getSnapshot()),
      () => selector(store.getSnapshot()),
   );
}

export function useCalendarStoreVersion() {
   return useCalendarStoreSnapshot((snapshot) => snapshot.version);
}
